import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DuplicateModel\GetDuplicateModelsListController::__invoke
* @see app/Http/Controllers/DuplicateModel/GetDuplicateModelsListController.php
* @route '/api/duplicate-models'
*/
const GetDuplicateModelsListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDuplicateModelsListController.url(options),
    method: 'get',
})

GetDuplicateModelsListController.definition = {
    methods: ["get","head"],
    url: '/api/duplicate-models',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DuplicateModel\GetDuplicateModelsListController::__invoke
* @see app/Http/Controllers/DuplicateModel/GetDuplicateModelsListController.php
* @route '/api/duplicate-models'
*/
GetDuplicateModelsListController.url = (options?: RouteQueryOptions) => {
    return GetDuplicateModelsListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DuplicateModel\GetDuplicateModelsListController::__invoke
* @see app/Http/Controllers/DuplicateModel/GetDuplicateModelsListController.php
* @route '/api/duplicate-models'
*/
GetDuplicateModelsListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDuplicateModelsListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DuplicateModel\GetDuplicateModelsListController::__invoke
* @see app/Http/Controllers/DuplicateModel/GetDuplicateModelsListController.php
* @route '/api/duplicate-models'
*/
GetDuplicateModelsListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDuplicateModelsListController.url(options),
    method: 'head',
})

export default GetDuplicateModelsListController